"use client";

import { c as _c } from "react/compiler-runtime";
import GoogleIcon from "@/app/(auth)/google-icon";
import { AuthDivider } from "@/components/auth/divider";
import { PhoneMethod } from "@/components/auth/methods/phone";
import { PhoneAuthStep } from "@/components/auth/methods/phone/phone-auth-context";
import { PhoneAuthError } from "@/components/auth/methods/phone/phone-auth-error";
import { Button } from "@/components/ui";
import { useSignUpAuth } from "./sign-up-auth";

/**
 * "Continue with Google" offer on the phone-entry step. Compose it only on
 * surfaces where the user hasn't picked a credential yet — it hides itself
 * once the flow is already on the Google variant.
 */
export function SignUpGoogleOption() {
  const $ = _c(4);
  const {
    googleEntry,
    chooseGoogle
  } = useSignUpAuth();
  if (googleEntry) {
    return null;
  }
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <AuthDivider />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <GoogleIcon className="h-5 w-5" aria-hidden={true} />;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== chooseGoogle) {
    t2 = <PhoneMethod.WhenStep step={PhoneAuthStep.ENTER_PHONE}>{t0}<Button variant="secondary" type="button" className="w-full" onClick={chooseGoogle} icon={t1}>Continue with Google</Button></PhoneMethod.WhenStep>;
    $[2] = chooseGoogle;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
}

/**
 * Everything after the phone number is submitted: SMS code, patient match,
 * name completion, and the terms footer. Each piece renders only on its own
 * step, so composing all four is the normal case.
 */
export function SignUpSteps() {
  const $ = _c(5);
  let t0;
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <PhoneMethod.Code className="space-y-6 p-0" />;
    t1 = <PhoneMethod.PickPatient className="space-y-6 p-0" />;
    t2 = <PhoneMethod.Name className="p-0" />;
    $[0] = t0;
    $[1] = t1;
    $[2] = t2;
  } else {
    t0 = $[0];
    t1 = $[1];
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <PhoneMethod.WhenStep step={PhoneAuthStep.NAME}><PhoneAuthError /></PhoneMethod.WhenStep>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <>{t0}{t1}{t2}{t3}<PhoneMethod.WhenStep step={PhoneAuthStep.PICK_PATIENT}><PhoneAuthError /></PhoneMethod.WhenStep><PhoneMethod.TAndS byText="creating an account" /></>;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  return t4;
}